"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MilesSaveCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MilesSaveCircleLinear = function MilesSaveCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.782 34.377A1 1 0 0032 35v2.5h-.5a1 1 0 100 2h.5V41a1 1 0 102 0v-3.14l1.218 1.528a1 1 0 001.564 0L38 37.859V41a1 1 0 102 0v-1.5h.5a1 1 0 100-2H40V35a1 1 0 00-1.782-.623L36 37.16l-2.218-2.783z",
    fill: "url(#MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint0_linear_17373_95650)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 15c-2.17 0-4.183.367-5.69.999-.751.315-1.424.716-1.925 1.212-.504.5-.885 1.154-.885 1.934 0 .044.001.087.004.13a1.032 1.032 0 00-.004.085v20.516c0 .78.381 1.435.885 1.934.5.496 1.174.897 1.925 1.212 1.507.632 3.52 1 5.69 1 1.93 0 3.734-.29 5.17-.8A9 9 0 1036 29a8.963 8.963 0 00-4 .937V19.36c0-.029-.001-.057-.003-.085.002-.043.003-.086.003-.13 0-.78-.381-1.434-.885-1.934-.5-.496-1.174-.897-1.925-1.212-1.507-.632-3.52-.999-5.69-.999zM17 19.145c0-.088.038-.261.294-.514.258-.256.683-.534 1.29-.788C19.79 17.337 21.528 17 23.5 17c1.971 0 3.709.337 4.917.843.605.255 1.03.532 1.29.788.255.253.293.426.293.514 0 .088-.038.261-.294.514-.258.257-.683.534-1.29.788-1.207.506-2.945.843-4.916.843-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514zm10.103 20.222c.11.725.307 1.42.58 2.077-1.135.355-2.582.577-4.183.577-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514v-1.538c.256.143.527.274.81.392 1.507.632 3.52 1 5.69 1 1.28 0 2.505-.128 3.603-.363zm.355-4.208a8.96 8.96 0 00-.434 2.175c-1.015.247-2.218.395-3.524.395-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514V34.21c.256.143.527.274.81.392 1.507.632 3.52 1 5.69 1 1.42 0 2.77-.158 3.958-.443zm1.362-2.587a9.056 9.056 0 011.18-1.28v-1.21a7.897 7.897 0 01-.81.392c-1.507.632-3.52 1-5.69 1-2.17 0-4.183-.368-5.69-1a7.897 7.897 0 01-.81-.393v1.375c0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.971 0 3.709-.337 4.917-.843a5.91 5.91 0 00.403-.186zM30 21.9a7.918 7.918 0 01-.81.392c-1.507.632-3.52 1-5.69 1-2.17 0-4.183-.368-5.69-1A7.918 7.918 0 0117 21.9v1.3c0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.971 0 3.709-.337 4.917-.843.605-.254 1.03-.531 1.29-.788.255-.253.293-.426.293-.514v-1.301zm0 4.054a7.897 7.897 0 01-.81.393c-1.507.632-3.52 1-5.69 1-2.17 0-4.183-.368-5.69-1a7.897 7.897 0 01-.81-.393v1.375c0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.971 0 3.709-.337 4.917-.843.605-.254 1.03-.531 1.29-.788.255-.253.293-.426.293-.514v-1.375zM36 31a7 7 0 100 14 7 7 0 000-14z",
    fill: "url(#MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint1_linear_17373_95650)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 20a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z",
    fill: "url(#MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint2_linear_17373_95650)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint3_linear_17373_95650)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint0_linear_17373_95650",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint1_linear_17373_95650",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint2_linear_17373_95650",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesSaveCircleLinear_svg__MilesSaveCircleLinear_svg__paint3_linear_17373_95650",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.MilesSaveCircleLinear = MilesSaveCircleLinear;
var _default = MilesSaveCircleLinear;
exports.default = _default;